import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms'; 

import { PaginationModule } from 'ngx-bootstrap/pagination';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { SharedPipesModule } from './../../pipes/shared-pipes.module';

import { NgTableComponent } from './ng-table.component';
import { NgTableFilteringDirective } from './ng-table-filtering.directive';
import { NgTablePagingDirective } from './ng-table-paging.directive';
import { NgTableSortingDirective } from './ng-table-sorting.directive';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,    
    PaginationModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TooltipModule.forRoot(),
    BrowserAnimationsModule,
    SharedPipesModule
  ],
  declarations: [
    NgTableComponent, 
    NgTableFilteringDirective, 
    NgTablePagingDirective, 
    NgTableSortingDirective
  ],
  exports: [
    NgTableComponent, 
    NgTableFilteringDirective, 
    NgTablePagingDirective, 
    NgTableSortingDirective
  ]
})

export class Ng2TableModule {
}